import { debounceTime, filter } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import {
  CustomComponent,
  getLengthWithoutLineBreakers,
  getLineBreakersQuantity,
  ngHelper
} from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'cake-text-section',
  templateUrl: './cake-text-section.component.html'
})
export class CakeTextSectionComponent extends CustomComponent implements OnChanges {
  @Input() public disabled: boolean;
  @Input() public text: string = '';
  @Input() public maxLength: number = 0;
  @Input() public price: number;
  @Input() public currency = 'kr';
  @Input() public helpText: string;
  @Output() public onChange: EventEmitter<any> = new EventEmitter();

  public textLength: number = 0;
  public textChanged$ = new Subject<string>();

  constructor() {
    super();
    this._subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'maxLength', (maxLength: any) => {
      if (this.text && getLengthWithoutLineBreakers(this.text) > maxLength) {
        const endPosition = maxLength + getLineBreakersQuantity(this.text);
        const text = this.text.substr(0, endPosition);

        setTimeout(() => {
          this.onChange.emit(text);
        });
      }
    });
  }

  private _subscribe() {
    this.addSubscriber(this.textChanged$.pipe(
      filter((text) => text !== undefined),
      debounceTime(50),)
      .subscribe((text) => {
        this.textLength = getLengthWithoutLineBreakers(text);
        const endPosition = this.maxLength + getLineBreakersQuantity(text);
        this.text = text.substr(0, endPosition);
        this.onChange.emit(this.text);
      }));
  }
}

